export { IconVerticalPosition } from './IconVerticalPosition';
export { type IconVerticalPositionProps } from './IconVerticalPosition.types';
